import { TinyMCE } from "tinymce";
import { ajaxRequest } from "../../Utils/Ajax/ajax";
import { errorToast, successToast, warningToast } from "../../Utils/utils";


declare let tinymce: TinyMCE

interface courseNameData {
    courseNameLong:string
    courseNameShort:string
    description:string
    allowExport:number
}

export class courseDetails {
    courseId:number;
    errorClass:string;
    saveBtn:JQuery

    constructor(courseId:number) {
        this.courseId = courseId;
        this.errorClass = 'is-invalid';
        this.saveBtn = $(".save-course-details");

        this.addListeners();
    }

    addListeners(){
        const handler = this;
        this.saveBtn.on("click", function(){
            handler.saveCourseDetails(handler.courseId, $(this));
        });
    }

    saveCourseDetails(courseId, btn){
        const data:courseNameData = {
            courseNameLong: $("#kurs_name_lang").val().toString(),
            courseNameShort: $("#kurs_name").val().toString(),
            description: tinymce.activeEditor.getContent(),
            allowExport:($('#allow_export').is(":checked")) ? 1 : 0,
        };


        const check = this.validateData(data);
        if (check){

            const url = '/course-management/tutor/' + courseId.toString() + '/update';

            const success = function(data){
                successToast('Eingaben wurden gespeichert', 'Erfolgreich!', 6500, true);
            }

            ajaxRequest(url, success, data, btn);

        }
    }

    validateData(data){
        $(".toast-container").remove();
        let status = true;
        // 1. check price
        if ( data.courseNameShort == ''){
            status = false;
            errorToast('Der Kurs muss einen Kurznamen haben (kann identisch sein mit dem normalen Namen)', 'Fehler mit der Kurzbezeichnung', 14500, true);
        }
        if (data.courseNameLong == ''){
            status = false;
            errorToast('Der Kurs muss einen Namen haben (kann identisch sein mit der Kurzbezeichnung)', 'Fehler mit dem Kursnamen', 14500, true);
        }
        if (data.description == ''){
            warningToast('Der Kurs sollte eine Beschreibung haben', 'Warnung!', 12500, true);
        }
        return status;
    }
}
